import { put } from './https';

export interface ServiceReportMaterial {
  material?: string;
  name?: string;
  unit?: string;
  qty?: number;
  quantity?: number;
  rate?: number;
  amount?: number;
  /** Rate entered by the technician on site; falls back to rate when absent. */
  userRate?: number;
  userAmount?: number;
}

export interface ServiceReportAc {
  serviceDetailId?: string;
  acType?: string;
  brandName?: string;
  yom?: number;
  tr?: number;
  inverter?: boolean;
  serviceType?: string;
  jobStatus?: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED';
  remark?: string;
  materials?: ServiceReportMaterial[];
  beforePhotos?: string[];
  afterPhotos?: string[];
  completedAt?: string;
}

export interface UpdateServiceReportPayload {
  acs: ServiceReportAc[];
  totalAmount?: number;
  paidAmount?: number;
  paymentStatus?: 'COMPLETE' | 'PARTIAL' | 'PENDING';
}

const UpdateServiceReport = async (
  bookingId: string,
  payload: UpdateServiceReportPayload,
) => {
  const result = await put(
    `/api/v1/admin/serviceReport/${bookingId}`,
    payload,
  );

  if (result?.status) {
    return result.data;
  }

  throw new Error(result?.message || 'Failed to update service report');
};

export { UpdateServiceReport };
